import { useEffect, useState } from 'react'
import { api } from '../api.js'
import Filtre, { useRecherche } from '../components/Filtre.jsx'

// Le cœur de la promesse : une commune n'écrit pas ses formulaires, elle
// choisit dans une bibliothèque déjà rédigée et paramétrée.
const CHAMPS_CATALOGUE = ['title', 'description', 'category']

// Recherche assistée : les propositions apparaissent au fil de la frappe, ce
// qui évite de deviner le mot exact employé dans le catalogue.
function Suggestions({ liste, valeur, onChange }) {
  const [ouvert, setOuvert] = useState(false)
  const trouvees = useRecherche(liste, valeur, CHAMPS_CATALOGUE).slice(0, 6)
  const montrer = ouvert && valeur.trim().length >= 2 && trouvees.length > 0

  return (
    <div className="autocomplete">
      <input type="search" value={valeur} aria-label="Rechercher une démarche"
             placeholder="acte, école, encombrants…" autoComplete="off"
             aria-expanded={montrer} role="combobox" aria-controls="suggestions"
             onChange={(e) => { onChange(e.target.value); setOuvert(true) }}
             onFocus={() => setOuvert(true)}
             onKeyDown={(e) => e.key === 'Escape' && setOuvert(false)}
             onBlur={() => setTimeout(() => setOuvert(false), 150)} />
      {montrer && (
        <ul id="suggestions" role="listbox">
          {trouvees.map((d) => (
            <li key={d.key} role="option" aria-selected="false">
              <button onMouseDown={() => { onChange(d.title); setOuvert(false) }}>
                <strong>{d.title}</strong>
                <span>{d.category}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default function Bibliotheque({ orgId, onOuvrir }) {
  const [liste, setListe] = useState([])
  const [partage, setPartage] = useState([])
  const [categorie, setCategorie] = useState('')
  const [q, setQ] = useState('')
  const [message, setMessage] = useState('')
  const [installee, setInstallee] = useState(null)

  const charger = () => {
    api.catalog().then(setListe)
    api.shared(orgId).then(setPartage).catch(() => setPartage([]))
  }
  useEffect(() => { charger() }, [orgId])   // eslint-disable-line

  const categories = [...new Set(liste.map((d) => d.category))]
  const cherchee = useRecherche(liste, q, CHAMPS_CATALOGUE)
  const filtree = cherchee.filter((d) => !categorie || d.category === categorie)

  async function installer(key, titre) {
    await api.install(key)
    // Plutôt qu'un message qui laisse seul devant l'écran, on propose la suite.
    setInstallee({ key, titre })
    charger()
  }

  return (
    <>
      <h1>Ajouter des démarches</h1>
      <p className="chapo">Des démarches complètes, prêtes à recevoir des dossiers : le formulaire,
        le circuit de traitement et les courriels sont installés d'un bloc.</p>
      {message && <p className="succes" role="status">{message}</p>}

      {installee && (
        <div className="fenetre" role="dialog" aria-label="Démarche ajoutée">
          <div className="fenetre-corps">
            <h2>« {installee.titre} » est ajoutée</h2>
            <p className="aide">Le formulaire, le circuit de traitement et les courriels sont
              installés. Il reste deux choses à décider, et vous pouvez le faire maintenant ou
              plus tard.</p>
            <ol className="suite">
              <li>
                <strong>Qui traite ces demandes</strong>
                <span>Sans service désigné, les dossiers arrivent sans destinataire.</span>
                <button className="btn sm pri" onClick={() => {
                  onOuvrir?.(installee.key, 'acces'); setInstallee(null)
                }}>Choisir maintenant</button>
              </li>
              <li>
                <strong>Mettre le portail à jour</strong>
                <span>La démarche n'est pas encore visible des habitants.</span>
              </li>
            </ol>
            <div className="ligne separee">
              <div className="pousse" />
              <button className="btn" onClick={() => {
                setMessage(`« ${installee.titre} » ajoutée. Pensez à mettre votre portail à jour.`)
                setInstallee(null)
              }}>Plus tard</button>
            </div>
          </div>
        </div>
      )}

      {partage.filter((p) => !p.already).length > 0 && (
        <section className="carte">
          <h2>Proposé par {partage[0].from}</h2>
          <p className="aide">Vous en devenez propriétaire : vos modifications ne remontent pas,
            et vous décidez vous-même de reprendre ou non les évolutions futures.</p>
          <div className="grille">
            {partage.filter((p) => !p.already).map((p) => (
              <article className="fiche" key={p.key}>
                <p className="cat">{p.category}</p>
                <h3>{p.title}</h3>
                <p>{p.description}</p>
                <button className="btn pri sm" onClick={async () => {
                  await api.adopt(orgId, p.key); charger()
                }}>Reprendre cette démarche</button>
              </article>
            ))}
          </div>
        </section>
      )}

      <div className="barre">
        <div className="onglets">
          <button className={!categorie ? 'on' : ''} onClick={() => setCategorie('')}>Tout</button>
          {categories.map((c) => (
            <button key={c} className={categorie === c ? 'on' : ''} onClick={() => setCategorie(c)}>{c}</button>
          ))}
        </div>
        <Suggestions liste={liste} valeur={q} onChange={setQ} />
      </div>

      <div className="grille">
        {filtree.map((d) => (
          <article className={`fiche ${d.installed ? 'installee' : ''}`} key={d.key}>
            <p className="cat">{d.category}</p>
            <h3>{d.title}{d.featured && <span className="badge">très demandée</span>}</h3>
            <p>{d.description}</p>
            <p className="mono petit">{d.questions} questions</p>
            {d.installed
              ? <span className="ok">installée</span>
              : <button className="btn pri sm" onClick={() => installer(d.key, d.title)}>
                  Ajouter à mon portail
                </button>}
          </article>
        ))}
      </div>
    </>
  )
}
